import { createAsyncThunk } from '@reduxjs/toolkit'
import { gameCloseService, loginService } from 'network/services/auth.service'
import { setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { ROUTE_PATHS } from 'utils/constants/index'
import { getAllCurrency } from './gameSettings.thunk'
import { signInSessionStorage, signOutSessionStorage } from 'utils/common-services/sessionStorage.service'

export const userLogin = createAsyncThunk('user/login', async ({ payload, history }, thunkApi) => {
  try {
    const res = await loginService(payload)
    if (res) {
      thunkApi.dispatch(setServerSeedHash(res?.serverSeedHash))
      signInSessionStorage({ token: res?.accessToken })
    }

    thunkApi.dispatch(getAllCurrency({ gameId: payload.gameId, currencyCode: payload.currencyCode }))
    return res
  } catch (error) {
    history.push(ROUTE_PATHS.error)
    return thunkApi.rejectWithValue(error[0].description)
  }
})

export const gameClose = createAsyncThunk('user/game-close', async (data, thunkApi) => {
  try {
    const res = await gameCloseService()
    if (res) {
      signOutSessionStorage()
    }
    return res
  } catch (error) {
    return thunkApi.rejectWithValue(error[0].description)
  }
})
